<template>
    <div :style="styles.widthLimitter">
      <video autoplay controls width="100%">
        <source :src="`${$aws_bucket_url}${src}`">
      </video>
    </div>
</template>

<script>
export default {
    props: [
      "maxWidth",
      "src",
    ],
    data() {
        return {
            styles: {
                widthLimitter: {
                    maxWidth: this.maxWidth ? this.maxWidth : null,
                },
            }
        };
    },
};
</script>
